import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data || data?.length === 0) return null

    return data.map(item => ({
      id: item.id,
      status: item.status,
      ...item.notification.metadata,
      created_at: item.notification.created_at,
      resource: {
        id: item.notification.resource_id,
        resource_table: item.notification.resource_table,
        resource_schema: item.notification.resource_schema,
      },
    }))
  }, [data])
}
